<template>
  <v-app>
    <v-main>
      <FeedBackForm/>
    </v-main>
  </v-app>
</template>

<script>
import FeedBackForm from './components/FeedBackForm';

export default {
  name: 'App',

  components: {
    FeedBackForm,
  },

  data: () => ({
    //
  }),
};
</script>
